import React from 'react';

const PageSection = ({ title, intro, children }) => {
  return (
    <section className="page-section">
      <div className="container">
        {title && <h2 className="section-title">{title}</h2>}
        {intro && <p className="section-intro">{intro}</p>}
        {children}
      </div>
    </section>
  );
};

export default PageSection;
